// extracted by mini-css-extract-plugin
export default {"thumbnailCarousel":"svgFu","thumbnail":"ZxRS1","selected":"Hx3VQ"};